import { render, staticRenderFns } from "./OptionalInheritors.vue?vue&type=template&id=ad554110&scoped=true"
import script from "./OptionalInheritors.vue?vue&type=script&lang=js"
export * from "./OptionalInheritors.vue?vue&type=script&lang=js"
import style0 from "./OptionalInheritors.vue?vue&type=style&index=0&id=ad554110&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad554110",
  null
  
)

export default component.exports